import { useFormikContext } from 'formik'
import { BaseInputWrapperProps } from '~/@/components/inputs/base/types'
import { Dropdown } from '~/@/components/inputs/selection/dropdown'
import { useGetActiveUsersQuery } from '~/common/generated/apollo-operations'
import { ActiveUser } from '../../../settings/types'
import { RecordCellEditOrigin } from '../../../table-cells/useEditableTableCellOriginProvider'
import { CellValue } from '../../add-record/AddRecordDialog'
import { useRecordDetailsCellPermissions } from '../../RecordDetailsCellPermissionsProvider'
import { AddRecordFormCell, RecordDetailTableCell } from '../../types'

interface UserArrayCellDetailsProps {
  fieldName: string
  cell: RecordDetailTableCell | AddRecordFormCell
  origin?: RecordCellEditOrigin | null
  value: CellValue
  inputWrapperProps?: BaseInputWrapperProps
}

/**
 * Renders record cell details for a column of type ARRAY with inner type User
 */
export function UserArrayCellDetails({
  fieldName,
  cell,
  origin,
  value,
  inputWrapperProps,
}: UserArrayCellDetailsProps) {
  const formik = useFormikContext<Record<string, ActiveUser[] | ActiveUser | null>>()
  const { data } = useGetActiveUsersQuery()
  const { isReadOnly } = useRecordDetailsCellPermissions()
  const isInTableCellPopup = origin === RecordCellEditOrigin.TABLE_DETAILS

  let cellValue: ActiveUser[] = []
  const isUserArray =
    value &&
    Array.isArray(value) &&
    value.length > 0 &&
    typeof value[0] === 'object' &&
    'firstName' in value[0]
  if (isUserArray) {
    cellValue = value as ActiveUser[]
  }

  const users = data?.activeUsers ?? []

  return (
    <Dropdown
      className={isInTableCellPopup ? 'max-w-[400px]' : undefined}
      disabled={isReadOnly}
      isMultiSelect
      onChange={(selectedValues) => {
        formik.setFieldTouched(fieldName, true)
        const selectedUsers = users.filter((user) => selectedValues?.includes(user.id))
        formik.setFieldValue(fieldName, selectedUsers)
      }}
      options={users.map((user) => ({
        label: `${user.firstName} ${user.lastName}`,
        value: user.id,
      }))}
      placeholder={cell.column.name}
      values={cellValue.map((user) => user.id)}
      {...inputWrapperProps}
    />
  )
}
